import React, { createContext, useContext, useMemo, useState, type ReactNode } from 'react';
import type { RarityKey } from '../utils/nftUtils';

export type CatalogPrizeFilter = 'all' | 'with_prizes' | 'without_prizes';

interface CatalogFilterContextValue {
  selectedPrices: Map<RarityKey, Set<number>>;
  setSelectedPrices: React.Dispatch<React.SetStateAction<Map<RarityKey, Set<number>>>>;
  selectedCharacterIds: Set<number>;
  setSelectedCharacterIds: React.Dispatch<React.SetStateAction<Set<number>>>;
  selectedPrizeFilter: CatalogPrizeFilter;
  setSelectedPrizeFilter: React.Dispatch<React.SetStateAction<CatalogPrizeFilter>>;
}

const CatalogFilterContext = createContext<CatalogFilterContextValue | undefined>(undefined);

/** Сохраняет применённые фильтры каталога между переходами главная ↔ карточка NFT. */
export const CatalogFilterProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [selectedPrices, setSelectedPrices] = useState<Map<RarityKey, Set<number>>>(() => new Map());
  const [selectedCharacterIds, setSelectedCharacterIds] = useState<Set<number>>(() => new Set());
  const [selectedPrizeFilter, setSelectedPrizeFilter] = useState<CatalogPrizeFilter>('all');

  const value = useMemo(
    () => ({
      selectedPrices,
      setSelectedPrices,
      selectedCharacterIds,
      setSelectedCharacterIds,
      selectedPrizeFilter,
      setSelectedPrizeFilter,
    }),
    [selectedPrices, selectedCharacterIds, selectedPrizeFilter]
  );

  return <CatalogFilterContext.Provider value={value}>{children}</CatalogFilterContext.Provider>;
};

export function useCatalogFilter(): CatalogFilterContextValue {
  const ctx = useContext(CatalogFilterContext);
  if (!ctx) {
    throw new Error('useCatalogFilter must be used within CatalogFilterProvider');
  }
  return ctx;
}
